// extracted by mini-css-extract-plugin
export default {"label":"reseller_info_label__lGw-v"};